"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.setGlobalConfig = exports.setScopedConfig = exports.registerCustomStrategy = void 0;
var selectStrategy_1 = require("./selectStrategy");
exports.registerCustomStrategy = selectStrategy_1.registerCustomStrategy;
var canvas;
selectStrategy_1.registerCustomStrategy("fill", function (ctx, options) {
    var getRadian = function (degree) { return (degree * Math.PI) / 180; };
    ctx.textAlign = "center";
    var width = ctx.canvas.width;
    var height = ctx.canvas.height;
    var padding = 100;
    ctx.translate((width / 2) * Math.tan(getRadian(options.rotate)), (-height / 2) * Math.tan(getRadian(options.rotate)));
    ctx.rotate((options.rotate * Math.PI) / 180);
    var x = 20;
    var y = 20;
    var addingX = true;
    while (y < height * 2) {
        ctx.fillText(options.content, x, y);
        if (x > width * 2) {
            x = 20;
            addingX = false;
        }
        if (addingX)
            x += padding;
        else {
            y += padding;
            addingX = true;
        }
    }
});
var defaultOptions = Object.freeze({
    mode: "fill",
    textBaseline: "middle",
    font: "15px Arial",
    fillStyle: "rgba(184, 184, 184, 0.8)",
    content: "请勿外传",
    rotate: 45,
});
var globalOptions = __assign({}, defaultOptions);
var scopedConfigMap = new WeakMap();
exports.setScopedConfig = function (opts, vm) {
    //@ts-ignore
    if (!vm._isVue)
        throw new Error("target isn't not a valid vue instance.");
    if (!scopedConfigMap.has(vm)) {
        scopedConfigMap.set(vm, __assign(__assign({}, defaultOptions), opts));
    }
    else {
        scopedConfigMap.set(vm, __assign(__assign({}, scopedConfigMap.get(vm)), opts));
    }
};
exports.setGlobalConfig = function (opts) {
    globalOptions = __assign(__assign({}, globalOptions), opts);
};
var getCanvas = function () {
    if (!canvas) {
        canvas = document.createElement("canvas");
        // canvas.style.display = "none";
        // canvas.style.position = "absolute";
        // canvas.style.zIndex = "-9999";
        // document.body.append(canvas);
    }
    return canvas;
};
var vueImgWatermark = {
    install: function (Vue) {
        Vue.directive("watermark", {
            bind: function (element, binding, VNode
            // oldVNode: VNode
            ) {
                var options;
                var bindingOptions = binding.value;
                if (scopedConfigMap.has(VNode.context)) {
                    options = __assign(__assign({}, scopedConfigMap.get(VNode.context)), bindingOptions);
                }
                else {
                    options = __assign(__assign({}, globalOptions), bindingOptions);
                }
                function loader() {
                    element.removeEventListener("load", loader);
                    var width = element.width, height = element.height;
                    var ctx = getCanvas().getContext("2d");
                    var textBaseline = options.textBaseline, fillStyle = options.fillStyle, font = options.font, mode = options.mode;
                    getCanvas().width = width;
                    getCanvas().height = height;
                    ctx.clearRect(0, 0, width, height);
                    ctx.drawImage(element, 0, 0, width, height);
                    ctx.textBaseline = textBaseline;
                    ctx.font = font;
                    ctx.fillStyle = fillStyle;
                    selectStrategy_1["default"](mode)(ctx, options);
                    var url = ctx.canvas.toDataURL();
                    //@ts-ignore
                    VNode.__url ? VNode.__url.push(url) : (VNode.__url = [url]);
                    element.src = url;
                    VNode.context.$emit("img:watermarked", element, options);
                    element.addEventListener("load", function temp() {
                        element.removeEventListener("load", temp);
                        element.addEventListener("load", loader);
                    });
                }
                element.setAttribute("crossorigin", "anonymous");
                element.addEventListener("load", loader);
            },
            unbind: function (el, binding, VNode) {
                //@ts-ignore
                VNode.__url && VNode.__url.map(URL.revokeObjectURL);
            },
        });
    },
};
exports["default"] = vueImgWatermark;
